export default {
    set: (object: any, key: any, value: any, proxy: any) => {
        if (Reflect.has(object, key)) {
            object[key] = value;
            object.updatedFields.add(key);
        } else {
            if (!object.customFieldsData) object.customFieldsData = {};
            object.customFieldsData[key] = value;
            object.updatedFields.add('customFieldsData');
        }
        return true;
    },

    get: (object: any, key: any, proxy: any) => {
        if (Reflect.has(object, key)) {
            return object[key]
        } else {
            // special case
            // A String value that is used in the creation of the default string description of an object. Called by the built-in method Object.prototype.toString.
            if (key === Symbol.toStringTag || ['@@toStringTag'].includes(key))
                return object.constructor.name;

            return _.get(object, 'customFieldsData.{0}'.f(key), undefined);
        }
    }
}
